var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C5.72727 0 1.65136 2.90267 0 7C1.65136 11.0973 5.72727 14 10.5 14C15.2727 14 19.3486 11.0973 21 7C19.3486 2.90267 15.2727 0 10.5 0ZM10.5 11.6667C7.86545 11.6667 5.72727 9.576 5.72727 7C5.72727 4.424 7.86545 2.33333 10.5 2.33333C13.1345 2.33333 15.2727 4.424 15.2727 7C15.2727 9.576 13.1345 11.6667 10.5 11.6667ZM10.5 4.2C8.91545 4.2 7.63636 5.45067 7.63636 7C7.63636 8.54933 8.91545 9.8 10.5 9.8C12.0845 9.8 13.3636 8.54933 13.3636 7C13.3636 5.45067 12.0845 4.2 10.5 4.2Z",
    fill: "#86B1C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.f4331374f5dd95402b750d03beb306a9.svg";
export { ForwardRef as ReactComponent };